<script lang="ts">
  import api, {fromApi, type MappedCallState } from "$parkito-api";
  import { writable } from "svelte/store";
  import { type Snippet, onMount } from "svelte";
  import { Hor, OnDesktop, Spacer, Header, BackArrowButton, Separator} from "$components";

  type Props = {
    headerRightContent?: Snippet,
    headerBottomContent?: Snippet,
    backButton?: boolean | "appOnly"
    content: Snippet,
    stickyHeaderOnApp?: boolean,
  } & ({
    title?: undefined,
    asyncTitle: MappedCallState<string>,
  } | {
    title: string,
    asyncTitle?: undefined,
  });

  const {
    headerRightContent,
    headerBottomContent,
    title,
    asyncTitle = fromApi(() => api.mock(title ?? "-")),
    backButton = true,
    content,
    stickyHeaderOnApp = true,
  }: Props = $props();

  const isLoadedFromApp =
  new URLSearchParams(window.location.search).get("app") === "true";

  const stickyHeader = (stickyHeaderOnApp && isLoadedFromApp);

  onMount(() => window.scrollTo(0, 0));

  const renderTitle = writable<string>(title ?? "-");
  $asyncTitle.onOk(s => renderTitle.set(s));


</script>
<div class="{stickyHeader ? "sticky top-[8px]" : undefined}"
>
  <OnDesktop>
    <Spacer minSpace="m"></Spacer>
  </OnDesktop>
  {#if stickyHeader}
    <div class="z-[-10] left-[-8px] top-[-8px] absolute border-t-solid border-t-[8px] 
      m-t-[-8px] border-t-grey-10 bg-grey-10 w-[calc(100%+16px)] h-[calc(100%+8px)]">
    </div>
  {/if}

  <div class="z-20  px-[1rem]" class:pb-[1rem]={!headerBottomContent}>
    <Hor margin="none">
      {#if backButton}
        <BackArrowButton appOnly={backButton === "appOnly"}></BackArrowButton>
      {/if}
      <Header size="2">{$renderTitle}</Header>
      <Spacer />
      {@render headerRightContent?.()}
    </Hor>
  </div>


  {#if headerBottomContent}
    <div class="px-[1rem] pt-[1.3rem] pb-[0.7rem]">
      {@render headerBottomContent?.()}
    </div>
  {/if}
  <Separator/>
</div>
<div class="p-[1rem]">
  {@render content()}
</div>
